import { call, put, takeLatest } from 'redux-saga/effects'
import Api from 'portal-modules/services/api'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'

// action types
const REQUEST_SERVICES = 'rp/services/REQUEST_SERVICES'
const RECEIVE_SERVICES = 'rp/services/RECEIVE_SERVICES'

// reducer
export default (state = {}, { type, payload }) => {
  switch (type) {
    case RECEIVE_SERVICES:
      return {
        ...state,
        ...payload,
      }
    default:
      return state
  }
}

// action creators
export const requestServices = () => ({ type: REQUEST_SERVICES })

// sagas
function* fetchServices() {
  const services = yield call(Api.getServices)
  if (services && services.length) {
    yield put({
      type: RECEIVE_SERVICES,
      payload: services.reduce(
        (obj, service) => ({
          ...obj,
          [service.id]: service,
        }),
        {},
      ),
    })
  }
}

function* watchRequestServices() {
  yield takeLatest(
    REQUEST_SERVICES,
    createRequestSaga(fetchServices, {
      key: 'services',
      message: __('Finding available services'),
    }),
  )
}

export const sagas = [watchRequestServices]
